import React from 'react';
import { isBlank } from 'utils/helperMethods';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Typography } from '@material-ui/core';

import Loader from 'sharedComponents/Loader';

import LoanOfficerCard from './components/LoanOfficerCard';
import useStyles from './useStyles';

const LoanOfficersList = props => {
  const { loanOfficers, isLoading, isDeleting, onDelete } = props;
  const classes = useStyles();
  const { t } = useTranslation();

  if (isLoading) {
    return (
      <div className={classes.loaderBox}>
        <Loader />
      </div>
    );
  }

  if (isBlank(loanOfficers)) {
    return (
      <div className={classes.container}>
        <Typography className={classes.emptyLabel} variant="subtitle1">
          {t('components.RealEstateAgentLoanOfficers.FavoriteLoanOfficersList.noLoanOfficers')}
        </Typography>
      </div>
    );
  }

  return (
    <div className={classes.container}>
      {loanOfficers.map(({ id, attributes }) => (
        <LoanOfficerCard key={id} loanOfficer={attributes} isDeleting={isDeleting} onDelete={onDelete} />
      ))}
    </div>
  );
};

LoanOfficersList.propTypes = {
  loanOfficers: PropTypes.arrayOf(PropTypes.shape()),
  isLoading: PropTypes.bool.isRequired,
  isDeleting: PropTypes.bool.isRequired,
  onDelete: PropTypes.func.isRequired,
};

LoanOfficersList.defaultProps = {
  loanOfficers: [],
};

export default LoanOfficersList;



// WEBPACK FOOTER //
// ./src/components/RealEstateAgentLoanOfficers/components/FavoriteLoanOfficersList/FavoriteLoanOfficersList.js